var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFileSignature = function SvgFileSignature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.333 9.457v17.21c0 2.334 0 3.5.455 4.392a4.167 4.167 0 0 0 1.82 1.82c.892.455 2.058.455 4.392.455h17.21M37.5 66.667 45.833 75l18.75-18.75m-6.25-47.916H36.667c-7.001 0-10.501 0-13.175 1.362a12.5 12.5 0 0 0-5.463 5.463c-1.362 2.673-1.362 6.174-1.362 13.175v43.333c0 7 0 10.5 1.362 13.175a12.5 12.5 0 0 0 5.463 5.462c2.674 1.363 6.174 1.363 13.175 1.363h26.666c7.001 0 10.501 0 13.175-1.363a12.5 12.5 0 0 0 5.463-5.462c1.362-2.674 1.362-6.174 1.362-13.175V33.333l-25-25Z",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgFileSignature;